import { FormikTouched } from 'formik';

import { ISignupErrors } from 'utils/form/types';

import { prepareErrorKeys } from './prepare-error-keys';

export const generateDisplayedErrors = (
  errorObj: ISignupErrors,
  touchedObj: FormikTouched<any>
): string[] => {
  const displayedErrors: Record<string, string> = {};

  // filter out displayed form errors on the screen
  // to avoid showing from in the accessibility errors alert
  prepareErrorKeys(errorObj).forEach(errorKey => {
    const key = errorKey as keyof ISignupErrors;
    if (touchedObj[key]) {
      displayedErrors[key] = errorObj[key] as string;
    }
  });

  return prepareErrorKeys(displayedErrors);
};
